// Generated from spelling-curriculum-100-lists.md. Do not edit by hand.
export type SpellingCurriculumLevel = {
  level: number;
  title: string;
  typicalGrade: string;
  pattern: string;
  words: readonly string[];
};

export const SPELLING_CURRICULUM: readonly SpellingCurriculumLevel[] = [
  {
    level: 1,
    title: "Short a CVC",
    typicalGrade: "late K–1",
    pattern: "One short vowel /ă/ in a three-letter word.",
    words: ["cat", "hat", "sat", "man", "ran", "map", "nap", "tap", "bag", "sad"],
  },
  {
    level: 2,
    title: "Short i CVC",
    typicalGrade: "late K–1",
    pattern: "Short /ĭ/.",
    words: ["sit", "pit", "hit", "big", "pig", "dig", "pin", "win", "bib", "kid"],
  },
  {
    level: 3,
    title: "Short o CVC",
    typicalGrade: "late K–1",
    pattern: "Short /ŏ/.",
    words: ["hot", "pot", "not", "dog", "log", "hop", "top", "box", "fox", "mop"],
  },
  {
    level: 4,
    title: "Short u CVC",
    typicalGrade: "late K–1",
    pattern: "Short /ŭ/.",
    words: ["sun", "run", "fun", "cup", "pup", "bus", "bug", "hug", "mud", "cut"],
  },
  {
    level: 5,
    title: "Short e CVC",
    typicalGrade: "late K–1",
    pattern: "Short /ĕ/.",
    words: ["bed", "red", "hen", "pen", "ten", "get", "net", "wet", "leg", "jet"],
  },
  {
    level: 6,
    title: "Mixed short-vowel CVC",
    typicalGrade: "late K–1",
    pattern: "Confirm all five short vowels in simple words.",
    words: ["cap", "fin", "cob", "gum", "web", "van", "rip", "job", "yes", "bud"],
  },
  {
    level: 7,
    title: "First heart words",
    typicalGrade: "late K–1",
    pattern: "High-frequency words to store as wholes. Mark the unexpected letters.",
    words: ["the", "a", "I", "to", "of", "you", "was", "for", "are", "said"],
  },
  {
    level: 8,
    title: "Final doubled consonants (-ll -ss -ff -zz)",
    typicalGrade: "grade 1",
    pattern: "After a short vowel in a one-syllable word, /l/ /s/ /f/ /z/ are often doubled.",
    words: ["bell", "well", "hill", "miss", "pass", "off", "puff", "buzz", "fizz", "jazz"],
  },
  {
    level: 9,
    title: "Final -ck",
    typicalGrade: "grade 1",
    pattern: "After a short vowel, /k/ is usually spelled ck.",
    words: ["back", "pack", "sick", "kick", "lock", "rock", "duck", "luck", "neck", "deck"],
  },
  {
    level: 10,
    title: "Final -ng and -nk",
    typicalGrade: "grade 1",
    pattern: "Glued sounds /ng/ and /ngk/.",
    words: ["sing", "ring", "long", "song", "hang", "sink", "pink", "bank", "junk", "thank"],
  },
  {
    level: 11,
    title: "Heart words set 2",
    typicalGrade: "grade 1",
    pattern: "More high-frequency irregulars needed for everyday writing.",
    words: ["he", "she", "they", "have", "one", "two", "what", "where", "come", "some"],
  },
  {
    level: 12,
    title: "Final blends -nd -nt -st -mp",
    typicalGrade: "grade 1",
    pattern: "Two consonants after the vowel; both sounds are heard.",
    words: ["and", "hand", "tent", "sent", "best", "nest", "jump", "lamp", "must", "last"],
  },
  {
    level: 13,
    title: "Open-syllable short words",
    typicalGrade: "grade 1",
    pattern: "A vowel at the end of a short word often says its name.",
    words: ["me", "be", "go", "no", "so", "hi", "my", "by", "why", "we"],
  },
  {
    level: 14,
    title: "More final blends -lt -lf -lk -sk -ft",
    typicalGrade: "grade 1",
    pattern: "Ending consonant clusters.",
    words: ["belt", "melt", "self", "milk", "silk", "desk", "mask", "gift", "left", "lift"],
  },
  {
    level: 15,
    title: "Heart words set 3",
    typicalGrade: "grade 1",
    pattern: "Common irregulars that keep showing up in sentences.",
    words: ["do", "who", "from", "were", "once", "does", "done", "any", "many", "very"],
  },
  {
    level: 16,
    title: "Initial l-blends",
    typicalGrade: "grade 1",
    pattern: "bl cl fl gl pl sl — both consonants are heard.",
    words: ["black", "clap", "flag", "glad", "plan", "slip", "blob", "clip", "flip", "plus"],
  },
  {
    level: 17,
    title: "Initial r-blends",
    typicalGrade: "grade 1",
    pattern: "br cr dr fr gr pr tr.",
    words: ["brim", "crab", "drip", "frog", "grin", "prim", "trap", "brick", "crop", "drum"],
  },
  {
    level: 18,
    title: "Initial s-blends",
    typicalGrade: "grade 1",
    pattern: "sc sk sm sn sp st sw.",
    words: ["scan", "skip", "smell", "snap", "spin", "stop", "swim", "scab", "snip", "stem"],
  },
  {
    level: 19,
    title: "Digraph sh",
    typicalGrade: "grade 1",
    pattern: "Two letters, one sound /sh/.",
    words: ["ship", "shop", "shut", "dish", "fish", "wish", "cash", "rush", "shed", "mash"],
  },
  {
    level: 20,
    title: "Digraph ch and tch",
    typicalGrade: "grade 1",
    pattern: "/ch/ is ch, or tch after a short vowel.",
    words: ["chip", "chop", "chin", "much", "such", "rich", "catch", "match", "hatch", "pitch"],
  },
  {
    level: 21,
    title: "Digraph th",
    typicalGrade: "grade 1",
    pattern: "th can be unvoiced (thin) or voiced (this).",
    words: ["thin", "thick", "path", "bath", "math", "this", "that", "then", "them", "with"],
  },
  {
    level: 22,
    title: "Digraphs wh and qu",
    typicalGrade: "grade 1",
    pattern: "wh = /w/ or /hw/; qu = /kw/ and the u is not a separate vowel.",
    words: ["when", "which", "whip", "whiz", "quiz", "quit", "quick", "quack", "quilt", "quite"],
  },
  {
    level: 23,
    title: "Silent-e long a (a_e)",
    typicalGrade: "grade 1",
    pattern: "Vowel-consonant-e: the e is silent and a says its name.",
    words: ["cake", "name", "late", "made", "gate", "same", "take", "gave", "lake", "fade"],
  },
  {
    level: 24,
    title: "Silent-e long i (i_e)",
    typicalGrade: "grade 1",
    pattern: "i_e = /ī/.",
    words: ["like", "time", "five", "ride", "bike", "hide", "line", "mine", "side", "smile"],
  },
  {
    level: 25,
    title: "Silent-e long o and u (o_e, u_e)",
    typicalGrade: "grade 1–2",
    pattern: "o_e = /ō/; u_e = /yoo/ or /oo/.",
    words: ["home", "hope", "rope", "note", "those", "use", "cute", "huge", "rule", "flute"],
  },
  {
    level: 26,
    title: "Silent-e long e and mixed CVCe",
    typicalGrade: "grade 1–2",
    pattern: "e_e is less common; mix the five silent-e vowels.",
    words: ["these", "theme", "Pete", "grape", "shine", "stone", "prune", "scene", "complete", "eve"],
  },
  {
    level: 27,
    title: "Soft c and soft g",
    typicalGrade: "grade 2",
    pattern: "c → /s/ and g → /j/ before e, i, or y.",
    words: ["cent", "cell", "city", "ice", "race", "gem", "gym", "giant", "page", "age"],
  },
  {
    level: 28,
    title: "-dge and -ge for /j/",
    typicalGrade: "grade 2",
    pattern: "After a short vowel, /j/ is usually dge.",
    words: ["edge", "badge", "fudge", "judge", "bridge", "large", "charge", "strange", "change", "range"],
  },
  {
    level: 29,
    title: "Contractions",
    typicalGrade: "grade 2",
    pattern: "The apostrophe stands for missing letters.",
    words: ["can't", "don't", "isn't", "didn't", "I'll", "we'll", "that's", "you're", "they're", "won't"],
  },
  {
    level: 30,
    title: "Heart words set 4",
    typicalGrade: "grade 2",
    pattern: "Workhorse irregulars for grade 2 writing.",
    words: ["friend", "because", "again", "could", "would", "should", "people", "pretty", "busy", "only"],
  },
  {
    level: 31,
    title: "Long a teams ai / ay",
    typicalGrade: "grade 2",
    pattern: "ai usually inside a word; ay usually at the end.",
    words: ["rain", "train", "wait", "paid", "paint", "play", "day", "stay", "way", "spray"],
  },
  {
    level: 32,
    title: "Long e teams ee / ea",
    typicalGrade: "grade 2",
    pattern: "Both often spell /ē/. (ea as /ĕ/ comes later.)",
    words: ["see", "tree", "green", "sleep", "keep", "eat", "read", "clean", "each", "dream"],
  },
  {
    level: 33,
    title: "Long o teams oa / ow",
    typicalGrade: "grade 2",
    pattern: "oa inside; ow often at the end for /ō/.",
    words: ["boat", "coat", "road", "soap", "toast", "snow", "grow", "show", "yellow", "window"],
  },
  {
    level: 34,
    title: "Long i teams igh / ie / y",
    typicalGrade: "grade 2",
    pattern: "igh = /ī/; final y in a one-syllable word = /ī/.",
    words: ["night", "light", "right", "high", "bright", "pie", "tie", "cry", "fly", "sky"],
  },
  {
    level: 35,
    title: "Long /oo/ teams oo / ew / ue",
    typicalGrade: "grade 2",
    pattern: "oo as in moon; ew and ue often /oo/ or /yoo/.",
    words: ["moon", "food", "soon", "room", "school", "new", "few", "grew", "blue", "true"],
  },
  {
    level: 36,
    title: "Short oo as in book",
    typicalGrade: "grade 2",
    pattern: "oo can also spell /ʊ/.",
    words: ["book", "look", "good", "wood", "stood", "foot", "cook", "hook", "shook", "wool"],
  },
  {
    level: 37,
    title: "R-controlled ar",
    typicalGrade: "grade 2",
    pattern: "ar = /är/ as in car.",
    words: ["car", "far", "farm", "park", "dark", "start", "hard", "yard", "sharp", "March"],
  },
  {
    level: 38,
    title: "R-controlled or / ore / oar",
    typicalGrade: "grade 2",
    pattern: "/ôr/ as in for, more, roar.",
    words: ["more", "store", "horse", "short", "north", "born", "roar", "board", "four", "door"],
  },
  {
    level: 39,
    title: "R-controlled er / ir / ur",
    typicalGrade: "grade 2–3",
    pattern: "All three commonly spell /ûr/.",
    words: ["her", "verb", "after", "first", "bird", "girl", "turn", "burn", "hurt", "church"],
  },
  {
    level: 40,
    title: "Diphthong oi / oy",
    typicalGrade: "grade 2–3",
    pattern: "oi inside; oy at the end.",
    words: ["oil", "boil", "coin", "join", "point", "noise", "boy", "toy", "enjoy", "destroy"],
  },
  {
    level: 41,
    title: "Diphthong ou / ow as /ow/",
    typicalGrade: "grade 2–3",
    pattern: "ou/ow = /ow/ as in out, cow. Contrast with long-o ow.",
    words: ["out", "shout", "cloud", "found", "house", "now", "how", "down", "brown", "flower"],
  },
  {
    level: 42,
    title: "Vowel au / aw / al",
    typicalGrade: "grade 2–3",
    pattern: "/aw/ as in saw, cause, ball.",
    words: ["saw", "draw", "straw", "paw", "cause", "pause", "walk", "talk", "small", "ball"],
  },
  {
    level: 43,
    title: "Silent letters kn wr gn mb",
    typicalGrade: "grade 2–3",
    pattern: "A letter is written but not heard.",
    words: ["know", "knee", "knife", "write", "wrong", "wrap", "gnat", "sign", "lamb", "thumb"],
  },
  {
    level: 44,
    title: "ea as short e; common ie",
    typicalGrade: "grade 3",
    pattern: "Unexpected ea = /ĕ/; ie often = /ē/.",
    words: ["bread", "head", "ready", "heavy", "instead", "piece", "field", "chief", "brief", "niece"],
  },
  {
    level: 45,
    title: "Homophones set 1",
    typicalGrade: "grade 3",
    pattern: "Same sound, different spelling and meaning. Always teach in a sentence.",
    words: ["too", "there", "their", "your", "its", "hear", "here", "sea", "dear", "deer"],
  },
  {
    level: 46,
    title: "Plurals -s and -es",
    typicalGrade: "grade 3",
    pattern: "Add es after s, x, z, ch, sh. Watch words ending in y.",
    words: ["boxes", "foxes", "dishes", "wishes", "lunches", "classes", "buses", "cities", "babies", "families"],
  },
  {
    level: 47,
    title: "Inflected ending -ed (three sounds)",
    typicalGrade: "grade 3",
    pattern: "-ed can say /t/, /d/, or /əd/. Do not invent a new syllable every time.",
    words: ["jumped", "helped", "asked", "played", "called", "rained", "wanted", "needed", "ended", "started"],
  },
  {
    level: 48,
    title: "Inflected ending -ing and the doubling rule",
    typicalGrade: "grade 3",
    pattern: "1+1+1: one syllable, one vowel, one final consonant → double before -ing/-ed.",
    words: [
      "running",
      "sitting",
      "hitting",
      "hopping",
      "shopping",
      "dropped",
      "stopped",
      "planned",
      "grabbed",
      "swimming",
    ],
  },
  {
    level: 49,
    title: "Drop silent e before -ing / -ed",
    typicalGrade: "grade 3",
    pattern: "If the base ends in silent e, drop it before a vowel suffix.",
    words: ["making", "taking", "riding", "hoping", "using", "smiled", "closed", "named", "lived", "saved"],
  },
  {
    level: 50,
    title: "Change y to i",
    typicalGrade: "grade 3",
    pattern: "When a word ends in consonant + y, change y to i before a suffix (except -ing).",
    words: ["tried", "cried", "fried", "carried", "studied", "happier", "funnier", "ladies", "puppies", "copies"],
  },
  {
    level: 51,
    title: "Compound words",
    typicalGrade: "grade 3",
    pattern: "Two bases keep their spellings when they join.",
    words: [
      "sunshine",
      "rainbow",
      "backpack",
      "bedroom",
      "football",
      "notebook",
      "cupcake",
      "firefly",
      "snowman",
      "mailbox",
    ],
  },
  {
    level: 52,
    title: "Open and closed two-syllable words",
    typicalGrade: "grade 3–4",
    pattern: "Closed syllable: vowel is short (nap-kin). Open syllable: vowel is long (ti-ger).",
    words: ["napkin", "basket", "picnic", "magnet", "rabbit", "tiger", "pilot", "music", "open", "begin"],
  },
  {
    level: 53,
    title: "VCCV syllable juncture",
    typicalGrade: "grade 3–4",
    pattern: "When two consonants stand between vowels, divide between them: nap/kin.",
    words: ["happen", "sudden", "better", "letter", "dinner", "summer", "butter", "pepper", "cotton", "muffin"],
  },
  {
    level: 54,
    title: "VCV syllable juncture",
    typicalGrade: "grade 4",
    pattern: "One consonant between vowels: try V/CV first (hu-man), then VC/V (cab-in).",
    words: ["human", "silent", "moment", "broken", "chosen", "cabin", "lemon", "robin", "finish", "never"],
  },
  {
    level: 55,
    title: "Final stable syllable -le",
    typicalGrade: "grade 3–4",
    pattern: "A consonant + le at the end is its own syllable (ta-ble, ap-ple).",
    words: ["table", "apple", "little", "middle", "bottle", "candle", "simple", "purple", "jungle", "eagle"],
  },
  {
    level: 56,
    title: "Homophones set 2",
    typicalGrade: "grade 3–4",
    pattern: "Meaning decides the spelling.",
    words: ["ate", "eight", "bare", "bear", "steal", "steel", "hour", "our", "waste", "waist"],
  },
  {
    level: 57,
    title: "Prefixes un- re- pre- dis-",
    typicalGrade: "grade 3–4",
    pattern: "A prefix is bolted on the front; the base spelling does not change.",
    words: ["unhappy", "unkind", "unfair", "redo", "rewrite", "reread", "preview", "preheat", "disagree", "dislike"],
  },
  {
    level: 58,
    title: "Suffixes -ful -less -ness -ly",
    typicalGrade: "grade 3–4",
    pattern: "These suffixes usually do not change the base (except y → i).",
    words: [
      "helpful",
      "careful",
      "hopeful",
      "homeless",
      "fearless",
      "kindness",
      "sadness",
      "slowly",
      "quickly",
      "finally",
    ],
  },
  {
    level: 59,
    title: "Comparative -er / -est",
    typicalGrade: "grade 3–4",
    pattern: "Add -er/-est; apply doubling, drop-e, and y-to-i rules.",
    words: ["bigger", "biggest", "hotter", "hottest", "safer", "safest", "nicer", "nicest", "happiest", "earliest"],
  },
  {
    level: 60,
    title: "Irregular plurals and odd past tenses",
    typicalGrade: "grade 4",
    pattern: "These have to be stored; pattern study still helps you notice them.",
    words: ["children", "mice", "teeth", "feet", "women", "men", "geese", "leaves", "wolves", "knives"],
  },
  {
    level: 61,
    title: "Unaccented final -er / -or / -ar",
    typicalGrade: "grade 4",
    pattern: "The last syllable often sounds like /ər/; spelling is a meaning/pattern choice.",
    words: ["teacher", "farmer", "dollar", "collar", "sugar", "doctor", "actor", "color", "favor", "motor"],
  },
  {
    level: 62,
    title: "Unaccented final -le / -el / -al / -il",
    typicalGrade: "grade 4–5",
    pattern: "Same /əl/ sound, four spellings. Sort by pattern; don't guess.",
    words: ["travel", "camel", "model", "level", "final", "total", "animal", "pencil", "fossil", "evil"],
  },
  {
    level: 63,
    title: "Unaccented final -en / -on / -in / -ain",
    typicalGrade: "grade 4–5",
    pattern: "Schwa in the last syllable.",
    words: ["garden", "often", "kitten", "person", "season", "reason", "cousin", "captain", "mountain", "fountain"],
  },
  {
    level: 64,
    title: "Three-syllable closed/open mixes",
    typicalGrade: "grade 4–5",
    pattern: "Chunk by syllable; keep short vowels closed.",
    words: [
      "fantastic",
      "remember",
      "together",
      "hospital",
      "energy",
      "library",
      "tomorrow",
      "calendar",
      "umbrella",
      "potato",
    ],
  },
  {
    level: 65,
    title: "Prefixes mis- non- over- under- mid-",
    typicalGrade: "grade 4–5",
    pattern: "Still: prefix + unchanged base.",
    words: [
      "misspell",
      "misplace",
      "nonstop",
      "nonprofit",
      "overeat",
      "overdue",
      "underline",
      "underwater",
      "midnight",
      "midyear",
    ],
  },
  {
    level: 66,
    title: "Suffixes -ment -tion early look / -sion intro",
    typicalGrade: "grade 4–5",
    pattern: "Noun-making suffixes. -tion is the most common /shən/.",
    words: [
      "payment",
      "movement",
      "statement",
      "excitement",
      "action",
      "nation",
      "station",
      "vacation",
      "fiction",
      "section",
    ],
  },
  {
    level: 67,
    title: "Suffixes -able / first -ible contrast",
    typicalGrade: "grade 5",
    pattern: "If you can hear a whole English base, it is often -able.",
    words: [
      "readable",
      "usable",
      "lovable",
      "comfortable",
      "valuable",
      "breakable",
      "possible",
      "terrible",
      "visible",
      "horrible",
    ],
  },
  {
    level: 68,
    title: "Suffixes -ous / -ious / -al",
    typicalGrade: "grade 5",
    pattern: "Turns a noun or bound base into an adjective.",
    words: [
      "famous",
      "dangerous",
      "nervous",
      "curious",
      "serious",
      "various",
      "national",
      "personal",
      "natural",
      "usual",
    ],
  },
  {
    level: 69,
    title: "Homophones set 3 (often-missed academic pairs)",
    typicalGrade: "grade 4–5",
    pattern: "Meaning first, then spelling.",
    words: ["accept", "except", "affect", "effect", "than", "weather", "whether", "witch", "principle", "principal"],
  },
  {
    level: 70,
    title: "Silent-letter review in longer words",
    typicalGrade: "grade 5",
    pattern: "kn wr mb gn plus silent t and silent h in common words.",
    words: ["unknown", "knowledge", "written", "wrapper", "climb", "comb", "design", "assign", "listen", "whistle"],
  },
  {
    level: 71,
    title: "ie / ei beyond the jingle",
    typicalGrade: "grade 5",
    pattern: "i before e except after c, or when it says /ā/. Then learn the real exceptions.",
    words: ["believe", "achieve", "relief", "thief", "receive", "ceiling", "deceive", "neighbor", "weigh", "weird"],
  },
  {
    level: 72,
    title: "ough family",
    typicalGrade: "grade 5",
    pattern: "One cluster, many sounds. Teach as a set, not as a rule.",
    words: ["though", "although", "thought", "bought", "brought", "fought", "enough", "rough", "tough", "through"],
  },
  {
    level: 73,
    title: "Words with ph = /f/ and ch = /k/",
    typicalGrade: "grade 5",
    pattern: "Greek fingerprints in everyday words.",
    words: ["phone", "photo", "alphabet", "chorus", "echo", "anchor", "chemist", "character", "scheme", "orchid"],
  },
  {
    level: 74,
    title: "Doubling in two-syllable words (accent matters)",
    typicalGrade: "grade 5",
    pattern: "Double the final consonant only if the last syllable is accented (beGIN → beginning).",
    words: [
      "beginning",
      "forgetting",
      "occurred",
      "referred",
      "admitted",
      "offered",
      "visited",
      "entered",
      "limited",
      "happened",
    ],
  },
  {
    level: 75,
    title: "Commonly misspelled grade 5 words",
    typicalGrade: "grade 5",
    pattern: "Schwa, unexpected vowels, and double letters.",
    words: [
      "separate",
      "definitely",
      "probably",
      "really",
      "until",
      "favorite",
      "different",
      "interesting",
      "surprise",
      "beautiful",
    ],
  },
  {
    level: 76,
    title: "Latin root port (carry)",
    typicalGrade: "grade 5–6",
    pattern: "port = carry. Build and take apart.",
    words: [
      "portable",
      "transport",
      "import",
      "export",
      "report",
      "support",
      "airport",
      "passport",
      "portal",
      "opportunity",
    ],
  },
  {
    level: 77,
    title: "Latin root tract / duc / duct",
    typicalGrade: "grade 6",
    pattern: "tract = pull; duc/duct = lead.",
    words: [
      "tractor",
      "attract",
      "subtract",
      "contract",
      "conduct",
      "educate",
      "produce",
      "introduce",
      "reduce",
      "product",
    ],
  },
  {
    level: 78,
    title: "Latin root scrib / script and graph",
    typicalGrade: "grade 6",
    pattern: "scrib/script = write; graph = write/draw.",
    words: [
      "scribble",
      "describe",
      "inscribe",
      "script",
      "manuscript",
      "graphic",
      "photograph",
      "autograph",
      "paragraph",
      "graphite",
    ],
  },
  {
    level: 79,
    title: "Latin root spect / vis / vid",
    typicalGrade: "grade 6",
    pattern: "spect = look; vis/vid = see.",
    words: ["inspect", "respect", "suspect", "spectator", "vision", "visit", "video", "provide", "visual", "revise"],
  },
  {
    level: 80,
    title: "Latin root dict / ject / rupt",
    typicalGrade: "grade 6",
    pattern: "dict = say; ject = throw; rupt = break.",
    words: [
      "dictate",
      "predict",
      "dictionary",
      "object",
      "reject",
      "project",
      "erupt",
      "interrupt",
      "rupture",
      "bankrupt",
    ],
  },
  {
    level: 81,
    title: "Greek roots phon / photo / tele / micro",
    typicalGrade: "grade 6",
    pattern: "phon = sound; photo = light; tele = far; micro = small.",
    words: [
      "telephone",
      "microphone",
      "symphony",
      "phonics",
      "photography",
      "telegraph",
      "telescope",
      "microscope",
      "microwave",
      "telephoto",
    ],
  },
  {
    level: 82,
    title: "Number prefixes mono uni bi tri oct",
    typicalGrade: "grade 6",
    pattern: "These prefixes travel across science and everyday English.",
    words: [
      "monotone",
      "monologue",
      "unicorn",
      "uniform",
      "bicycle",
      "bilingual",
      "triangle",
      "tripod",
      "octopus",
      "octagon",
    ],
  },
  {
    level: 83,
    title: "Assimilated prefix in- (il- im- ir-)",
    typicalGrade: "grade 6",
    pattern: "in- (not) changes to match the next letter: illegal, impossible, irregular.",
    words: [
      "incomplete",
      "incorrect",
      "invisible",
      "illegal",
      "illogical",
      "impossible",
      "impatient",
      "imperfect",
      "irregular",
      "irresponsible",
    ],
  },
  {
    level: 84,
    title: "Assimilated prefixes com- / ad- / sub-",
    typicalGrade: "grade 6–7",
    pattern: "com- → col- cor-; ad- → ac- af- ag- al- an- ap- ar- as- at-; sub- → suc- suf- sug-.",
    words: ["collect", "correct", "combine", "announce", "appear", "arrive", "attach", "succeed", "suffix", "suggest"],
  },
  {
    level: 85,
    title: "-tion / -sion / -cian contrast",
    typicalGrade: "grade 6–7",
    pattern: "/shən/ has three common spellings tied to the base.",
    words: [
      "attention",
      "invention",
      "direction",
      "decision",
      "explosion",
      "division",
      "musician",
      "magician",
      "physician",
      "electrician",
    ],
  },
  {
    level: 86,
    title: "-ence / -ance and -ent / -ant",
    typicalGrade: "grade 6–7",
    pattern: "Related pairs: differ → different → difference. Keep the vowel consistent inside a family.",
    words: [
      "difference",
      "patience",
      "patient",
      "importance",
      "evident",
      "distance",
      "distant",
      "absence",
      "absent",
      "silence",
    ],
  },
  {
    level: 87,
    title: "Schwa in the middle of longer words",
    typicalGrade: "grade 6–7",
    pattern: "The mumbled vowel is the #1 cause of misspelling after grade 4.",
    words: [
      "category",
      "definite",
      "desperate",
      "privilege",
      "similar",
      "opinion",
      "original",
      "president",
      "secretary",
      "excellent",
    ],
  },
  {
    level: 88,
    title: "Grade 6 academic workhorses",
    typicalGrade: "grade 6",
    pattern: "Words students meet in every subject and still misspell.",
    words: [
      "recommend",
      "guarantee",
      "foreign",
      "height",
      "rhythm",
      "vacuum",
      "license",
      "anxious",
      "conscience",
      "mischief",
    ],
  },
  {
    level: 89,
    title: "Greek roots bio / geo / hydr / therm",
    typicalGrade: "grade 7",
    pattern: "bio = life; geo = earth; hydr = water; therm = heat.",
    words: [
      "biology",
      "biosphere",
      "geology",
      "geode",
      "hydrant",
      "hydrogen",
      "dehydrate",
      "thermos",
      "thermometer",
      "thermal",
    ],
  },
  {
    level: 90,
    title: "Greek roots chron / metr / path / phil",
    typicalGrade: "grade 7",
    pattern: "chron = time; metr = measure; path = feeling; phil = love.",
    words: [
      "chronic",
      "chronicle",
      "synchronize",
      "metric",
      "diameter",
      "perimeter",
      "sympathy",
      "empathy",
      "pathology",
      "philosophy",
    ],
  },
  {
    level: 91,
    title: "Latin roots bene / mal / cred / fid",
    typicalGrade: "grade 7",
    pattern: "bene = good; mal = bad; cred = believe; fid = trust.",
    words: [
      "benefit",
      "beneficial",
      "benign",
      "malice",
      "malicious",
      "malfunction",
      "credit",
      "incredible",
      "confident",
      "fidelity",
    ],
  },
  {
    level: 92,
    title: "Latin roots pend / pos / mit / miss",
    typicalGrade: "grade 7",
    pattern: "pend = hang; pos = put; mit/miss = send.",
    words: [
      "pendant",
      "depend",
      "suspend",
      "position",
      "opposite",
      "compose",
      "transmit",
      "mission",
      "dismiss",
      "permission",
    ],
  },
  {
    level: 93,
    title: "Connected spelling-meaning families",
    typicalGrade: "grade 7–8",
    pattern: "If you can spell the base, you can often spell the whole family — even when the vowel sound changes.",
    words: [
      "please",
      "pleasant",
      "pleasure",
      "resign",
      "signal",
      "signature",
      "define",
      "definition",
      "compete",
      "competition",
    ],
  },
  {
    level: 94,
    title: "More meaning families (vowel change across forms)",
    typicalGrade: "grade 7–8",
    pattern: "The silent or reduced vowel in one form is pronounced in a related form.",
    words: [
      "nature",
      "naturalist",
      "historic",
      "historical",
      "politics",
      "political",
      "economy",
      "economic",
      "critic",
      "critical",
    ],
  },
  {
    level: 95,
    title: "Hard -able vs -ible and -ary vs -ery",
    typicalGrade: "grade 7–8",
    pattern: "Use the base test for -able; store the rest in families.",
    words: [
      "reliable",
      "available",
      "acceptable",
      "responsible",
      "flexible",
      "accessible",
      "vocabulary",
      "stationery",
      "ordinary",
      "military",
    ],
  },
  {
    level: 96,
    title: "Double-consonant academic words",
    typicalGrade: "grade 7–8",
    pattern: "Two sets of doubles are a common trap.",
    words: [
      "possession",
      "profession",
      "success",
      "occasion",
      "aggressive",
      "necessary",
      "embarrass",
      "occurrence",
      "accommodate",
      "millennium",
    ],
  },
  {
    level: 97,
    title: "7th–8th commonly missed school words",
    typicalGrade: "grade 7–8",
    pattern: "These appear in essays and still get marked wrong.",
    words: [
      "argument",
      "judgment",
      "acknowledgment",
      "independent",
      "immediately",
      "unfortunately",
      "especially",
      "environment",
      "government",
      "temperature",
    ],
  },
  {
    level: 98,
    title: "Science and social-studies vocabulary",
    typicalGrade: "grade 7–8",
    pattern: "Content words whose spelling follows Greek/Latin parts.",
    words: [
      "hypothesis",
      "organism",
      "photosynthesis",
      "metamorphosis",
      "atmosphere",
      "constitution",
      "democracy",
      "legislature",
      "amendment",
      "civilization",
    ],
  },
  {
    level: 99,
    title: "Dense prefixed academic words",
    typicalGrade: "grade 8",
    pattern: "Peel prefixes from the inside out.",
    words: [
      "unprecedented",
      "incomprehensible",
      "unconstitutional",
      "indiscriminate",
      "reconciliation",
      "disintegration",
      "misinterpretation",
      "unpredictable",
      "inconsiderate",
      "transformation",
    ],
  },
  {
    level: 100,
    title: "Grade 8 capstone list",
    typicalGrade: "grade 8",
    pattern: "Long, irregular, or morphologically packed words a strong 8th-grade speller should own.",
    words: [
      "conscientious",
      "acquaintance",
      "maintenance",
      "perseverance",
      "questionnaire",
      "liaison",
      "bureaucracy",
      "psychological",
      "phenomenon",
      "entrepreneur",
    ],
  },
];
